exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fuel-surcharge-branch-dd .multiSelect .checkboxLayer {\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_billing/components/fuel_surcharges/create/fuel_surcharges.create.scss
// module id = 1119
// module chunks = 1